import React from "react";
import { Box, Typography } from "@mui/material";
import MemgoLogo from "../../assets/media/memgo-logo.svg";

const ComingSoon: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100vw",
        height: "100vh",
        backgroundColor: "#ffffff",
        margin: 0,
        padding: 0,
        boxSizing: "border-box",
      }}
    >
      {/* Logo Container */}
      <Box
        sx={{
          padding: "16px 16px 16px 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#ffffff",
          mb: 4,
        }}
      >
        <Box
          component="img"
          src={MemgoLogo}
          alt="MemorialGo Logo"
          sx={{
            height: { xs: "72px", sm: "90px", md: "100px" },
            width: "auto",
          }}
        />
      </Box>

      {/* Tagline */}
      {/* <Typography
        sx={{
          fontSize: { xs: "24px", sm: "32px", md: "40px" },
          fontWeight: 500,
          fontFamily: "Inter, sans-serif",
          textAlign: "center",
          lineHeight: 1.2,
          mb: 5,
        }}
      >
        <span style={{ color: "#15585D" }}>Connecting </span>
        <span style={{ color: "#9a8557" }}>Deathcare</span>
      </Typography> */}

      {/* Main Title */}
      <Typography
        sx={{
          fontSize: { xs: "36px", sm: "48px", md: "64px" },
          fontWeight: 600,
          color: "#9a8557",
          letterSpacing: "0.1em",
          textAlign: "center",
          fontFamily: "Inter, sans-serif",
          lineHeight: 1.2,
        }}
      >
        COMING SOON
      </Typography>
    </Box>
  );
};

export default ComingSoon;
